/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios';
import authHeader from './auth-header';
import http from './http-common';
import { API_URLU } from '../config/constant';

const getUserById = (id) => {
  return axios.get(API_URLU + 'user/' + id, { headers: authHeader() });
};

const getUsers = () => {
  return axios.get(API_URLU + 'user', { headers: authHeader() });
};

const postUser = (data) => {
  return axios.post(API_URLU + 'user/', data, { headers: authHeader() });
};

const getByUsername = (username) => {
  return axios.get(API_URLU + 'userName/' + username, { headers: authHeader() });
};

const getCompById = (id) => {
  return axios.get(API_URLU + 'company/' + id, { headers: authHeader() });
};

const getCompanies = () => {
  return axios.get(API_URLU + 'company', { headers: authHeader() });
};

const postComp = (data) => {
  return axios.post(API_URLU + 'company', data, { headers: authHeader() });
};

const getSystemById = (id) => {
  return axios.get(API_URLU + 'system/' + id, { headers: authHeader() });
};

const getSystems = () => {
  return axios.get(API_URLU + 'system', { headers: authHeader() });
};

const postSystem = (data) => {
  return axios.post(API_URLU + 'system', data, { headers: authHeader() });
};

const postUserComp = (data) => {
  return axios.post(API_URLU + 'ucompany', data, { headers: authHeader() });
};

// const getUserCompbk = (data) => {
//   return axios.get(API_URLU + 'ucompany/', data, { headers: authHeader() });
// };
const getUserComp = (id) => {
  return axios.get(API_URLU + 'user-companies?userId=' + id, { headers: authHeader() });
};

const postUserSystems = (data) => {
  return axios.post(API_URLU + 'user-systems', data, { headers: authHeader() });
};

const getCompSystems = () => {
  return axios.get(API_URLU + 'company-systems', { headers: authHeader() });
};

const getUserCompSystems = () => {
  return axios.get(API_URLU + 'user-company-systems', { headers: authHeader() });
};

const getUserCompUSystems = () => {
  return axios.get(API_URLU + 'user-company-usystems', { headers: authHeader() });
};

const getCustomerById = (id) => {
  return axios.get(API_URLU + 'customer/' + id, { headers: authHeader() });
};

const getCustomers = () => {
  return axios.get(API_URLU + 'customer', { headers: authHeader() });
};

const postCustomer = (data) => {
  return axios.post(API_URLU + 'customer', data, { headers: authHeader() });
};

const putCustomer = (id, data) => {
  return axios.put(API_URLU + 'customer/' + id, data, { headers: authHeader() });
};

const getEmployeeByCode = (id) => {
  return axios.get(API_URLU + 'chr_by_code/' + id, { headers: authHeader() });
};

const getEmployeeByUsername = (name) => {
  return axios.get(API_URLU + 'chr_by_vusername/' + name, { headers: authHeader() });
};

const getEmployeeDepartments = (id) => {
  return axios.get(API_URLU + 'chr_deptartments/' + id, { headers: authHeader() });
};

const getEmployeeByCategoryCode = (code) => {
  return axios.get(API_URLU + 'chr_by_category/' + code, { headers: authHeader() });
};

const getEmployeeByDepartmentCode = (code) => {
  return axios.get(API_URLU + 'depart_employees?departmentCode=' + code, { headers: authHeader() });
};

const getEmployeeLeaveByDepartmentCode = (code) => {
  return axios.get(API_URLU + 'depart_employee-leave?departmentCode=' + code, { headers: authHeader() });
};

const getEmployees = () => {
  return axios.get(API_URLU + 'chr_employee', { headers: authHeader() });
};

const getEmployeeById = (id) => {
  return axios.get(API_URLU + 'chr_employee/' + id, { headers: authHeader() });
};

const getPagedEmployees = (offset, pageSize) => {
  return axios.get(API_URLU + 'employee/' + offset + '/' + pageSize, { headers: authHeader() });
};

const postEmployee = (data) => {
  return axios.post(API_URLU + 'employee', data, { headers: authHeader() });
};

const putEmployee = (id, data) => {
  return axios.put(API_URLU + 'employee/' + id, data, { headers: authHeader() });
};

const getClassification = () => {
  return axios.get(API_URLU + 'classification', { headers: authHeader() });
};

const getGeneral = () => {
  return axios.get(API_URLU + 'general', { headers: authHeader() });
};

const postTempBranch = (data) => {
  return axios.post(API_URLU + 'tbranch', data, { headers: authHeader() });
};

const getTempBranch = () => {
  return axios.get(API_URLU + 'tbranch', { headers: authHeader() });
};

const saveInvoice = (invoice) => {
  return axios.post(API_URLU + 'SaveInvoice', invoice, { headers: authHeader() });
};

const getInvoiceInfo = () => {
  return axios.get(API_URLU + 'getInfo', { headers: authHeader() });
};

const getScheduledLeaves = (employeCode) => {
  return axios.get(API_URLU + 'scheduled_leaves?employeeCode=' + employeCode, { headers: authHeader() });
};

const postLeaveSchedule = (data) => {
  return axios.post(API_URLU + 'scheduled_leaves', data, { headers: authHeader() });
};

const getLeaveAccruals = () => {
  return axios.get(API_URLU + 'leave_accruals', { headers: authHeader() });
};

const getLeaveAccrualsvw = (employeCode) => {
  return axios.get(API_URLU + 'leaveAccrualsVW?employeeCode=' + employeCode, { headers: authHeader() });
};

const getLeaveApplications = () => {
  return axios.get(API_URLU + 'leave_applications', { headers: authHeader() });
};

const getLeaveApplicationsvw = (employeCode) => {
  return axios.get(API_URLU + 'leaveApplicationVW?employeeCode=' + employeCode, { headers: authHeader() });
};

const postLeaveApplication = (data) => {
  return axios.post(API_URLU + 'leave_applications', data, { headers: authHeader() });
};

const getLeaveTransactions = () => {
  return axios.get(API_URLU + 'leave_transactions', { headers: authHeader() });
};

const getLeaveTransactionsvw = (employeCode) => {
  return axios.get(API_URLU + 'leaveTransactionVW?employeeCode=' + employeCode, { headers: authHeader() });
};

const getLeaveRejections = (employeCode) => {
  return axios.get(API_URLU + 'leave_rejections?employeeCode=' + employeCode, { headers: authHeader() });
};

const getLeaveTypes = (employeeCode) => {
  return axios.get(API_URLU + 'leave_types?employeeCode=' + employeeCode, { headers: authHeader() });
};

const getReturnDate = (data) => {
  return axios.get(
    API_URLU +
      'return_date?startDate=' +
      data.startDate +
      '&appliedDays=' +
      data.appliedDays +
      '&leaveCode=' +
      data.leaveCode +
      '&cmpId=' +
      data.cmpId,
    { headers: authHeader() }
  );
};

const getEmpCategory = () => {
  return axios.get(API_URLU + 'icr_employee_category', { headers: authHeader() });
};

const postEmpCategory = (data) => {
  return axios.post(API_URLU + 'icr_employee_category', data, { headers: authHeader() });
};

const getBanks = () => {
  return axios.get(API_URLU + 'vw_banks', { headers: authHeader() });
};

const getEmpRecurrents = (code) => {
  return axios.get(API_URLU + 'chr_emp_recurrentbycode/' + code, { headers: authHeader() });
};

const getPayPeriods = () => {
  return axios.get(API_URLU + 'pay-period', { headers: authHeader() });
};

const getChrTempMonthlies = (data) => {
  return axios.get(API_URLU + 'chr_temp_monthlies_byCode?employeeCode=' + data.employeeCode + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const getChrMonthliesView = (data) => {
  return axios.get(API_URLU + 'chr_temp_monthlies_view?employeeCode=' + data.employeeCode + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

// const uploadFile = (file) => {
//   let formData = new FormData();

//   formData.append('file', file);
//   return axios.post(API_URLU + 'singleUpload', formData, { headers: authHeader() });
// };

const uploadFile = (file) => {
  let formData = new FormData();

  formData.append('file', file);

  return http.post('/singleUpload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

const uploadExcel = (file) => {
  let formData = new FormData();

  formData.append('file', file);

  return http.post('/upload_chr_employees', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

const getFiles = () => {
  return http.get('/files');
};

const getMonthlyFigures = (data) => {
  return axios.get(
    API_URLU +
      'genMonthlyFigures?cmpId=' +
      data.cmpId +
      '&categoryCode=' +
      data.categoryCode +
      '&period=' +
      data.period +
      '&employeeCode=' +
      data.employeeCode +
      '&username=' +
      data.username +
      '&pFromDate=' +
      data.pFromDate +
      '&pToDate=' +
      data.pToDate,
    { headers: authHeader() }
  );
};

const purgeMonthlyFigures = (data) => {
  return axios.get(API_URLU + 'purgeMonthlyFigures?employeeCode=' + data.employeeCode + '&categoryCode=' + data.categoryCode, {
    headers: authHeader()
  });
};

const updatePass = (data) => {
  return axios.patch(API_URLU + 'changepwd', data, { headers: authHeader() });
};

const updateUser = (data) => {
  return axios.get(
    API_URLU + 'update-user-profile?id=' + data.id + '&longName=' + data.longName + '&email=' + data.email + '&phone=' + data.phone,
    { headers: authHeader() }
  );
};

const updateUserImg = (data) => {
  return axios.get(API_URLU + 'update-user-image?id=' + data.id + '&photoUrl=' + data.photoUrl, { headers: authHeader() });
};

const getApprovalRights = (username) => {
  return axios.get(API_URLU + 'chr_approve_rights_username?userName=' + username, { headers: authHeader() });
};

const getReports = () => {
  return axios.get(API_URLU + 'temp_pay_reports', { headers: authHeader() });
};

const runReport = (repname, format, period) => {
  return axios.get(API_URLU + 'report/' + repname + '/' + format + '?period=' + period, { headers: authHeader() });
};

const getProvpayvarsum2 = (period) => {
  return axios.get(API_URLU + 'chr_rp_hrProvpayvarsum2?period=' + period, { headers: authHeader() });
};

const preparatoryApp = (data) => {
  return axios.get(
    API_URLU +
      'preparatory_approval?cmpId=' +
      data.cmpId +
      '&period=' +
      data.period +
      '&categoryCode=' +
      data.categoryCode +
      '&username=' +
      data.username,
    { headers: authHeader() }
  );
};

const verificationApp = (data) => {
  return axios.get(
    API_URLU +
      'verification_approval?cmpId=' +
      data.cmpId +
      '&period=' +
      data.period +
      '&categoryCode=' +
      data.categoryCode +
      '&username=' +
      data.username,
    { headers: authHeader() }
  );
};

const finalApp = (data) => {
  return axios.get(
    API_URLU +
      'final_approval?cmpId=' +
      data.cmpId +
      '&period=' +
      data.period +
      '&categoryCode=' +
      data.categoryCode +
      '&username=' +
      data.username,
    { headers: authHeader() }
  );
};

const getPayMonthSummary = (data) => {
  return axios.get(API_URLU + 'chr_pay_month_sum?period=' + data.period + '&categoryCode=' + data.categoryCode + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const getFinalMonthliesCount = (period) => {
  return axios.get(API_URLU + 'chr_final_monthlies_count?period=' + period, { headers: authHeader() });
};

const getCloseCurrentPeriod = (username) => {
  return axios.get(API_URLU + 'close_current_period?username=' + username, { headers: authHeader() });
};

const getRecurrents_ed = (data) => {
  return axios.get(API_URLU + 'chr_recurrents_ed?cmpId=' + data.cmpId + '&employeeCode=' + data.employeeCode, { headers: authHeader() });
};

const saveRecurrents_ed = (data) => {
  return axios.get(
    API_URLU +
      'save-recurrent?employeeCode=' +
      data.employeeCode +
      '&paramCode=' +
      data.paramCode +
      '&startDate=' +
      data.startDate +
      '&endDate=' +
      data.endDate +
      '&edAmount=' +
      data.edAmount +
      '&eerContribute=' +
      data.eerContribute +
      '&eerPA=' +
      data.eerPA +
      '&eerVal=' +
      data.eerVal +
      '&cmpId=' +
      data.cmpId,
    { headers: authHeader() }
  );
};

const updateRecurrents_ed = (data) => {
  return axios.get(
    API_URLU +
      'update-recurrent?edAmount=' +
      data.edAmount +
      '&startDate=' +
      data.startDate +
      '&endDate=' +
      data.endDate +
      '&ercId=' +
      data.ercId +
      '&eerContribute=' +
      data.eerContribute +
      '&eerPA=' +
      data.eerPA +
      '&eerVal=' +
      data.eerVal,
    { headers: authHeader() }
  );
};

const getPayParams = () => {
  return axios.get(API_URLU + 'pay_params', { headers: authHeader() });
};

const getMenuLevels = (data) => {
  return axios.get(API_URLU + 'get-menus?sstId=' + data.sstId, {
    headers: authHeader()
  });
};

const getAttendance = (code) => {
  return axios.get(API_URLU + 'employee-attendance-list?employeeCode=' + code, {
    headers: authHeader()
  });
};

const genAttendanceAll = (code) => {
  return axios.get(
    API_URLU + 'gen-attendance-all?firstDate=' + code.firstDate + '&lastDate=' + code.lastDate + '&username=' + code.username,
    {
      headers: authHeader()
    }
  );
};

const getTaskScheduleByEmpCode = (code) => {
  return axios.get(API_URLU + 'task-schedule-empCode/' + code, { headers: authHeader() });
};

const getTaskRequestByEmpCode = (code) => {
  return axios.get(API_URLU + 'task-request-empCode/' + code, { headers: authHeader() });
};

const getTaskRequestByDepCode = (code) => {
  return axios.get(API_URLU + 'task-request-depCode/' + code, { headers: authHeader() });
};

const getDepartments = () => {
  return axios.get(API_URLU + 'get-departments', {
    headers: authHeader()
  });
};

const getHdeskTypes = () => {
  return axios.get(API_URLU + 'get-hdesk-types', {
    headers: authHeader()
  });
};

const postTaskRequest = (data) => {
  return axios.post(API_URLU + 'task-request', data, { headers: authHeader() });
};

const postTaskSchedule = (data) => {
  return axios.post(API_URLU + 'task-schedule', data, { headers: authHeader() });
};

const getDepartEmployees = (code) => {
  return axios.get(API_URLU + 'get-depart-emp?departmentCode=' + code, {
    headers: authHeader()
  });
};

const getHodTaskApproval = (code) => {
  return axios.get(API_URLU + 'hod-approve-task?hdeskId=' + code, {
    headers: authHeader()
  });
};

const postDoneStatus = (data) => {
  return axios.get(
    API_URLU +
      'update-done-status?done=' +
      data.doneYn +
      '&doneBy=' +
      data.doneBy +
      '&doneComments=' +
      data.doneDescription +
      '&doneDate=' +
      data.doneDate +
      '&hdeskId=' +
      data.hdeskId,
    { headers: authHeader() }
  );
};

const postCloseStatus = (data) => {
  return axios.get(
    API_URLU +
      'update-close-status?closed=' +
      data.closeYn +
      '&closedBy=' +
      data.closedBy +
      '&closedComments=' +
      data.closedDescription +
      '&closedDate=' +
      data.closedDate +
      '&hdeskId=' +
      data.hdeskId,
    { headers: authHeader() }
  );
};

const postDiscardedStatus = (data) => {
  return axios.get(
    API_URLU +
      'update-discarded-status?discarded=' +
      data.discarded +
      '&discardedBy=' +
      data.discardedBy +
      '&discardedReason=' +
      data.discardedReason +
      '&discardedDate=' +
      data.discardedDate +
      '&hdeskId=' +
      data.hdeskId,
    { headers: authHeader() }
  );
};

const getAppraisalTypes = () => {
  return axios.get(API_URLU + 'get-app-types', {headers: authHeader()});
}

const postAppraisalTasks = (data) => {
  return axios.get(API_URLU + 'save_appraisal_tasks?tranYear=' + data.tranYear + '&tranMonth=' + data.tranMonth + '&indDeptComp=' + data.indDeptComp + '&appraisalType=' +data.appraisalType + '&taskDate=' + data.taskDate + '&reviewEndDate=' +data.revEndDate + '&firstRevDate=' +data.firstRevDate + '&secRevDate=' +data.secondRevDate + '&thirdRevDate=' + data.thirdRevDate + '&actualAppDate=' + data.actualAppDate, {headers: authHeader()});
}

const getAppraisalTaskAreas = () => {
  return axios.get(API_URLU + 'get-app-factors', {headers: authHeader()});
}


const saveAppraisalTaskAreas =(data) => {
  return axios.get(API_URLU + 'savePerpectives?atsId=' + data.atsId + '&factorCode=' + data.code +'&lines=' +data.lines+ '&category=' +data.category, {headers: authHeader()});
}

const generateAppraisalTemplate = (data) => {
  return axios .get(API_URLU + 'gen-appraisal-tasks?atsId=' + data.atsId + '&cmpId=' + data.cmpId + '&indDeptComp=' + data.indDeptComp + '&deptCode=' + data.deptCode + '&empCode=' + data.empCode + '&appType=' + data.appType + '&usrId=' + data.usrId+ '&actualAppDate=' + data.actualAppDate+ '&firstRevDate=' + data.firstRevDate + '&appTaskDate=' + data.appTaskDate + '&secondRevDate=' + data.secondRevDate + '&thirdRevDate=' + data.thirdRevDate + '&reviewEndDate=' + data.reviewEndDate, {headers: authHeader()});
}

const getAppraisalSchedules = (data) => {
  return axios.get(API_URLU + 'appraisal-schedules?employeeCode=' + data.employeeCode, {headers: authHeader()});
}

const getUserAppraisalSchedules = (data) => {
  return axios.get(API_URLU + 'appraisal-schedules?employeeCode=' + data, {headers: authHeader()});
}

const getAppraisalScoresa = (data) => {
  return axios.get(API_URLU + 'appraisal-scoresa?atsId=' + data.atsId + '&employeeCode=' + data.employeeCode, {headers: authHeader()});
}

const fetchAppEdit = (rowData) => {
  return axios.get(API_URLU + 'appraisal-scoresa?atsId=' + rowData.atsId + '&employeeCode=' + rowData.employeeCode, {headers: authHeader()});
}

const getAppraisalScores = (data) => {
  return axios.get(API_URLU + 'appraisal-scores?atsId=' + data.atsId + '&employeeCode=' + data.employeeCode + '&sectionCode=' + data.sectionCode + '&measureId=' + data.measureId, {headers: authHeader()});
}

const getIndItem = (data) => {
  return axios.get(API_URLU + 'getIndReqs?reqNumber='+data.reqNumber,{headers:authHeader()});
}

const updateAppraisalScores = (data) => {
  return axios.get(API_URLU + 'update-appraisal-score?atsId=' + data.atsId + '&employeeCode=' + data.employeeCode + '&sectionCode=' +data.sectionCode+ '&measureId=' +data.measureId +
    '&objectiveDescr=' +data.objectiveDescr+ '&initiativeDescr=' +data.initiativeDescr+ '&measureDescr=' + '&target=' +data.target +
     '&apprAchievement=' + data.apprAchievement+ '&status=' +data.status+ '&initiativeToEndYear=' + data.initiativeToEndYear +
     '&proExtention=' + data.proExtention + '&directorysComments=' +data.directorysComments+ '&selfRating=' +data.selfRating + '&finalRating=' + data.finalRating + '&overall=' +data.overall + '&modifiedBy=' + data.modifiedBy + '&modifiedDate=' + data.modifiedDate, {headers: authHeader()});
}

const printRept = (data) => {
  return axios.get(API_URLU + 'appraisal-reports?reportFormat=?' + data.reportFormat + '&repName=' + data.repName + '&atsId=' + data.atsId + '&employeeCode=' + data.employeeCode, {headers: authHeader()});
}


const signDocument = (data) => {
  return axios.get(API_URLU + 'signDoc?atsId=' + data.atsId + '&employeeCode=' + data.empId,{headers: authHeader()})
}

const getPendingRegs = (data) => {
  return axios.get(API_URLU + 'getPendingReqs?employeeCode=' + data, {headers: authHeader()})
}

const getRejectedApprovedRegs = (data) => {
  return axios.get(API_URLU + 'getPendingapprovalReqs?employeeCode=' + data, {headers: authHeader()})
}

const getAllApprovedReqs = () => {
  return axios.get(API_URLU + 'getAllApprovedReqs',{headers:authHeader()})
}

const getAllIssuedReqs = () => {
  return axios.get(API_URLU + 'getAllIssuedReqs',{headers:authHeader()})
}

const updateItemReq = (data) => {
  return axios.get(API_URLU + 'updateIndReqItem?reqNumber=' + data, {headers: authHeader()})
}
const getApprovedReqs = (data) => {
  return axios.get(API_URLU + 'getApprovedReqs?employeeCode=' + data, {headers: authHeader()})
}

const getItemReqs = async(data) => {
  return axios.get(API_URLU + 'getItemReqs?reqType=' + data, {headers: authHeader()})
}

const storeRequisitions = async(data) =>{
  return axios.get(API_URLU + 'storeRequisitions?p_req_TYPE=' + data.code + '&p_item_CODE=' + data.itemcode + '&p_unit_CODE=' + data.unitcode + '&p_no_of_UNITS=' + data.noofunits + '&p_employeeCode=' + data.employeeCode + '&p_USERNAME=' + data.username + '&p_io_TYPE=' + data.ioType + '&p_branch_CODE=' + data.branch + '&p_departments_CODE=' + data.department + '&p_request_COMMENTS=' + data.comments, {headers:authHeader()})
}

const getRejectedReqs = (data) => {
  return axios.get(API_URLU + 'getRejectedReqs?employeeCode=' + data, {headers: authHeader()})
}
const updateItemReqStatus = (data) =>{
  return axios.get(API_URLU + 'updateIndReqItem?reqNumber=' + data.id + '&approvedBy=' + data.approvedBy + '&approvedDate=' + data.approvedDate, {headers:authHeader()})
}
const updateItemIssued = (data) => {
  return axios.get(API_URLU + 'updateItemIssued?reqNumber=' + data.reqNumber + '&issued=' + data.issued + '&issued_units='  + data.issued_units + '&issuedUnitCode=' + data.issuedUnitCode + '&dateIssued=' + data.dateIssued + '&issuedBy=' + data.issuedBy + '&receivedDate=' + data.receivedDate, {headers: authHeader()})
}
const recallApproval = (data) => {
  return axios.get(API_URLU + 'recalApprovedItem?reqNumber=' + data.reqNumber, {headers:authHeader()})
}

const updateItemUnit = (data) => {
  return axios.get(API_URLU + 'changeNoofItem?no_OF_UNITS=' + data.no_OF_UNITS + '&reqNumber=' + data.reqNumber , {headers:authHeader()})
}

const getAppPositions = (appId) => {
  return axios.get(API_URLU + 'app-positions?appId='+ appId,{headers:authHeader()});
}

const getAppQualifications = (appId) => {
  return axios.get(API_URLU + 'app-qualification?appId='+ appId,{headers:authHeader()});
}

const PostAppQualifications = (data) => {
  return axios.post(API_URLU + 'app-qualification', data, {headers:authHeader()});
}

const updateAppQualifications = (data) => {
  return axios.put(API_URLU + 'app-qualification/' + data.pqlId, data, {headers:authHeader()});
}

const getAppextraCur = (appId) => {
  return axios.get(API_URLU + 'app-extra-cur?appId='+ appId,{headers:authHeader()});
}

const PostAppextraCur = (data) => {
  return axios.post(API_URLU + 'app-extra-cur', data, {headers:authHeader()});
}

const updateAppextraCur = (data) => {
  return axios.put(API_URLU + 'app-extra-cur/' + data.pxcId, data, {headers:authHeader()});
}

export default {
  getUserById,  getUsers,  postUser,  getByUsername,  getCompById,  getCompanies,  postComp,  getSystemById,  getSystems,
  postSystem,  postUserComp,  postUserSystems,  getUserComp,  getCompSystems,  getUserCompSystems,
  getUserCompUSystems,  getCustomerById,  getCustomers,  postCustomer,  putCustomer,  getEmployeeByCode,  getEmployeeByUsername,
  getEmployeeDepartments,  getEmployeeByCategoryCode,  getEmployeeByDepartmentCode,  getEmployees,  getPagedEmployees,  postEmployee,
  putEmployee,  getClassification,  getGeneral,  getFiles,  saveInvoice,  getInvoiceInfo,  getScheduledLeaves,
  postLeaveSchedule,  getLeaveAccruals,  getLeaveApplications,  postLeaveApplication,  getLeaveTransactions,  getLeaveRejections,  getLeaveTypes,
  getReturnDate,  uploadFile,  uploadExcel,  postTempBranch,  getTempBranch,  getEmpCategory,  postEmpCategory,  getBanks,
  getEmpRecurrents,  getPayPeriods,  getChrTempMonthlies,  getChrMonthliesView,  getMonthlyFigures,  purgeMonthlyFigures,
  updatePass,  updateUser,  updateUserImg,  getApprovalRights,  getProvpayvarsum2,  getReports,  runReport,  preparatoryApp,
  verificationApp,  finalApp,  getPayMonthSummary,  getFinalMonthliesCount,  getCloseCurrentPeriod,
  getRecurrents_ed,  updateRecurrents_ed,  saveRecurrents_ed,  getPayParams,  getEmployeeById,  getLeaveAccrualsvw,  getLeaveApplicationsvw,
  getLeaveTransactionsvw,  getEmployeeLeaveByDepartmentCode,  getMenuLevels,  getAttendance,  genAttendanceAll,
  getTaskScheduleByEmpCode,  getTaskRequestByEmpCode,  getDepartments,  getHdeskTypes,  postTaskRequest,  getTaskRequestByDepCode,
  getDepartEmployees,  postTaskSchedule,  getHodTaskApproval,  postDoneStatus,  postCloseStatus,  postDiscardedStatus,
  getAppraisalTypes,postAppraisalTasks,getAppraisalTaskAreas,saveAppraisalTaskAreas,generateAppraisalTemplate,getAppraisalSchedules,
  getAppraisalScoresa,getAppraisalScores,updateAppraisalScores,getUserAppraisalSchedules,fetchAppEdit,signDocument,printRept,
  getPendingRegs,getItemReqs,storeRequisitions,getApprovedReqs,getRejectedReqs,getRejectedApprovedRegs,updateItemReq,updateItemReqStatus,
  getAllApprovedReqs,updateItemIssued,getAllIssuedReqs,recallApproval,getIndItem,updateItemUnit,getAppPositions,getAppQualifications,
  PostAppQualifications,updateAppQualifications,getAppextraCur,PostAppextraCur,updateAppextraCur
};
